/* knowledge-cards-topics.tsx generated by @compiled/babel-plugin v0.38.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Box } from '@atlaskit/primitives/compiled';
import { AITopicsByPerson } from '../ai-topics';
var styles = {
  root: ""
};
export var KnowledgeCardsTopics = function KnowledgeCardsTopics(props) {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.root
  }, /*#__PURE__*/React.createElement(AITopicsByPerson, props));
};